module.exports = __webpack_public_path__ + "static/media/yourdata_03.adf8d767.jpg";